import React from "react";
import CircleVisualizerV3 from "./CircleVisualizerV3";

function App() {
  return <CircleVisualizerV3 />;
}

export default App;
